import { ref, readonly } from 'vue';
import { post, ENDPOINTS, guideErrorMessage, guideHttpStatus, BASE_URL, MainApi } from '@/api/mainApi';
import store from '@/store';

export interface InvoiceData {
  donationId: number;
  invoiceEmail?: string;
}

export function useInvoiceOperations() {
  const loading = ref(false);
  const error = ref<string | null>(null);

  const createInvoice = async (invoiceData: InvoiceData): Promise<any> => {
    loading.value = true;
    error.value = null;

    try {
      const result = await post(ENDPOINTS.INVOICE, invoiceData);
      return result;
    } catch (err) {
      error.value = 'Failed to create invoice';
      window.log?.error('[Guide] invoice.create — Failed to create invoice', {
        message: guideErrorMessage(err),
        httpStatus: guideHttpStatus(err),
        donationId: invoiceData.donationId,
      });
      store.commit('setSnackbar', { active: true, color: 'error', text: error.value });
      throw err;
    } finally {
      loading.value = false;
    }
  };

  const getInvoiceDocumentUrl = (
    serialNumber: string,
    asImage: boolean = false,
    disposition: string = 'inline'
  ): string => {
    return `${BASE_URL}/${MainApi}/${ENDPOINTS.INVOICE}/${ENDPOINTS.DOCUMENT}?serialNumber=${serialNumber}&asImage=${asImage}&disposition=${disposition}`;
  };

  return {
    loading: readonly(loading),
    error: readonly(error),
    createInvoice,
    getInvoiceDocumentUrl,
  };
}
